/**
 * Application timeout constants
 * All timeout values are in milliseconds
 */

// API Request Timeouts
export const API_TIMEOUTS = {
  // Standard API requests
  STANDARD: 15000,
  
  // Extended timeout for complex operations
  EXTENDED: 30000,
  
  // Payment processing timeout
  PAYMENT: 60000,
  
  // Authentication timeout
  AUTH: 30000,
} as const

// Cypress Test Timeouts
export const CYPRESS_TIMEOUTS = {
  // Standard element visibility
  ELEMENT_VISIBLE: 10000,
  
  // Extended timeout for slow operations
  EXTENDED_OPERATION: 20000,
  
  // Very long timeout for complex operations
  LONG_OPERATION: 200000,
} as const

// Legacy timeout values (for backwards compatibility)
export const LEGACY_TIMEOUTS = {
  ESTO_NOTIFY: 59000,
} as const
